//import React from 'react';
//import { makeStyles } from "@mui/styles";
import {Typography, Card, CardContent, CardHeader} from '@mui/material';
//import ASPECStyles from "../../../../../styles/jss/components/apps/ASPECStyles";

//const useStyles = makeStyles(ASPECStyles);

const ActivityLog = (props) => {
    //const classes = useStyles();
    const {data} = props;
    return(
        <Card style={{height: '100%'}}>
            <CardHeader
                title={'Activity Log'}
                sx={{
                  "&": {
                    padding: '16px 16px 0 16px',
                    alignItems: 'flex-start'
                  }
                }}
                slotProps={{
                  title: {
                    fontSize: '20px'
                  }
                }}
            />
            <CardContent sx={{padding: '0, 16px, 16px, 16px'}}>
                {data.activityLog.map((item, idx) => (
                    <div key={idx}>
                        <Typography variant={'caption'}>{item.title}</Typography>
                        <Typography variant={'body1'}>{item.content}</Typography>
                    </div>
                ))}
            </CardContent>
        </Card>
    )
}

export default ActivityLog;